import React, { useEffect, useState } from "react";

const ArticleAddEditModal = ({ isOpen, onClose, onSave, initialData }) => {
  const emptyForm = {
    image: "",
    title: "",
    description: "",
    category: "",
    posted: "",
  };

  const [form, setForm] = useState(emptyForm);

  useEffect(() => {
    if (!isOpen) return;
    if (initialData) {
      setForm({ ...initialData });
    } else {
      setForm({ ...emptyForm, posted: new Date().toISOString().slice(0, 10) });
    }
  }, [isOpen, initialData]);

  function handleSubmit(e) {
    e.preventDefault();
    if (!form.title.trim()) {
      alert("Please provide a title.");
      return;
    }

    onSave({
      // fallback placeholder image when empty
      image:
        form.image.trim() ||
        "https://via.placeholder.com/1200x675?text=No+Image",
      title: form.title.trim(),
      description: form.description.trim(),
      category: form.category.trim() || "Uncategorized",
      posted: form.posted || new Date().toISOString().slice(0, 10),
    });
  }

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-2xl w-full max-w-2xl p-6 shadow-2xl ring-1 ring-slate-100">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-semibold">
            {initialData ? "Edit Article" : "Add Article"}
          </h2>
          <button onClick={onClose} className="text-slate-600">
            ✕
          </button>
        </div>

        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-1 md:grid-cols-2 gap-4"
        >
          <div className="col-span-1 md:col-span-2">
            <label className="block text-sm font-medium text-slate-700">
              Title
            </label>
            <input
              value={form.title}
              onChange={(e) =>
                setForm((f) => ({ ...f, title: e.target.value }))
              }
              placeholder="Article headline"
              className="mt-1 w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#5989C8] focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700">
              Category
            </label>
            <input
              value={form.category}
              onChange={(e) =>
                setForm((f) => ({ ...f, category: e.target.value }))
              }
              placeholder="e.g., Travel, Tips, Guides"
              className="mt-1 w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#5989C8] focus:border-transparent"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700">
              Posted Date
            </label>
            <input
              type="date"
              value={form.posted}
              onChange={(e) =>
                setForm((f) => ({ ...f, posted: e.target.value }))
              }
              className="mt-1 w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#5989C8] focus:border-transparent"
            />
          </div>

          <div className="col-span-1 md:col-span-2">
            <label className="block text-sm font-medium text-slate-700">
              Image URL
            </label>
            <input
              value={form.image}
              onChange={(e) =>
                setForm((f) => ({ ...f, image: e.target.value }))
              }
              placeholder="https://..."
              className="mt-1 w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#5989C8] focus:border-transparent"
            />
            <p className="text-xs text-slate-400 mt-1">
              Paste an image URL or leave blank to use a placeholder.
            </p>
          </div>

          <div className="col-span-1 md:col-span-2">
            <label className="block text-sm font-medium text-slate-700">
              Description
            </label>
            <textarea
              value={form.description}
              onChange={(e) =>
                setForm((f) => ({ ...f, description: e.target.value }))
              }
              rows={5}
              placeholder="Write the article summary or lead paragraph..."
              className="mt-1 w-full border rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#5989C8] focus:border-transparent"
            />
          </div>

          <div className="col-span-1 md:col-span-2 flex items-center justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 rounded-lg border"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 rounded-lg bg-gradient-to-r from-[#5989C8] to-[#064585] text-white"
            >
              Save Article
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ArticleAddEditModal;
